import Screening from './screening';
import { connect } from 'react-redux';

import { redux } from '../../api';

const { changeMenuTaskFn } = redux.actions;

const mapStateToProps = state => {
  const viewportIndex = state.viewports.activeViewportIndex;
  const viewportData = state.viewports.viewportSpecificData[viewportIndex];
  const objectUid = viewportData && viewportData.sopInstanceUid;

  return {
    objectUid,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeMenuTaskData: data => {
      dispatch(changeMenuTaskFn(data));
    },
  };
};

const ConnectedScreening = connect(
  mapStateToProps,
  mapDispatchToProps
)(Screening);

export default ConnectedScreening;
